// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyB4HkBRt4-KYc58XWxicX0nbBbHwxJVWpc',
  authDomain: 'sachdientu-cloud.firebaseapp.com',
  databaseURL: 'https://sachdientu-cloud.firebaseio.com',
  projectId: 'sachdientu-cloud',
  storageBucket: 'sachdientu-cloud.appspot.com',
  messagingSenderId: '596542930788',
  appId: '1:596542930788:web:9d14d0dd7e5fd2a09fc471',
  measurementId: 'G-H49MRQD709',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
